import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class ConfirmationModalDetail {
  // old 2-button mode
  constructor(
    public title: string,
    public body: string,
    public confirmText?: string,
    public declineText?: string,
    public confirmColour?: 'primary' | 'accent' | 'warn',
    public declineColour?: 'primary' | 'accent' | 'warn',

    // new 3-button mode
    public deleteText?: string,
    public disableText?: string,
    public cancelText?: string,
    public deleteColour?: 'primary' | 'accent' | 'warn',
    public disableColour?: 'primary' | 'accent' | 'warn',
    public cancelColour?: 'primary' | 'accent' | 'warn',
    public mode: 'confirm-decline' | 'delete-disable' = 'confirm-decline',
  ) {}
}

@Component({
  standalone: false,
  selector: 'odin-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./confirmation-modal.component.scss'],
})
export class ConfirmationModalComponent {
  constructor(
    private dialogRef: MatDialogRef<ConfirmationModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: ConfirmationModalDetail
  ) {}

  // old 2-button methods
  public decline(): void {
    this.dialogRef.close(false);
  }
  public confirm(): void {
    this.dialogRef.close(true);
  }

  // new 3-button methods
  public delete(): void {
    this.dialogRef.close('delete');
  }

  public disable(): void {
    this.dialogRef.close('disable');
  }

  public cancel(): void {
    this.dialogRef.close('cancel');
  }
}